(function () {
  'use strict';

  var bq = window.bq;
  if (!bq) return;

  function init(host) {
    if (!host || host.dataset.bqProfileInit) return;
    host.dataset.bqProfileInit = '1';

    // Goes straight into an href: https:// or a site-relative path only
    // (a lone '/' would still let '//host' through).
    var FALLBACK_URL = /^(https:\/\/|\/(?!\/))/.test(host.dataset.fallbackUrl || '')
      ? host.dataset.fallbackUrl
      : 'https://christine-mtc.fr';

    // French is embedded as the fallback so a missing key never surfaces raw; these
    // are display only, slug() and the CSS classes keeping the canonical values.
    var I18N = {};
    try {
      var i18nEl = document.getElementById('bq-profile-i18n');
      if (i18nEl) I18N = JSON.parse(i18nEl.textContent || '{}');
    } catch (e) { I18N = {}; }
    function t(key, fallback) {
      var v = I18N[key];
      return (typeof v === 'string' && v && v.indexOf('Translation missing') === -1) ? v : fallback;
    }
    function mvtLabel(m) { return t('mvt_' + m, m); }

    var emptyEl    = document.getElementById('bq-profile-empty');
    var contentEl  = document.getElementById('bq-profile-content');
    var chapoEl    = document.getElementById('bq-profile-chapo');
    var portraitEl = document.getElementById('bq-profile-portrait-text');
    var readingsEl = document.getElementById('bq-profile-readings');
    var divergenceEl = document.getElementById('bq-profile-divergence');
    var confianceEl = document.getElementById('bq-profile-confiance');
    var productsEl = document.getElementById('bq-profile-products');
    var redoBtn = document.getElementById('bq-profile-redo');

    var profile = null;
    try {
      var raw = localStorage.getItem('botaqi_profile');
      if (raw) profile = JSON.parse(raw);
    } catch (e) { profile = null; }

    if (!profile || !profile.mouvement || !profile.filtres) {
      emptyEl.hidden = false;
      return;
    }

    contentEl.hidden = false;

    var ELEM_CN = { 'Bois': '木', 'Feu': '火', 'Terre': '土', 'Métal': '金', 'Eau': '水' };
    // Locale suffix of each movement, the key the plate template is filed under.
    var ELEM_KEY = { 'Bois': 'wood', 'Feu': 'fire', 'Terre': 'earth', 'Métal': 'metal', 'Eau': 'water' };

    var glyphEl = document.getElementById('bq-profile-glyph');
    if (glyphEl) glyphEl.textContent = ELEM_CN[profile.mouvement] || '';

    mountPlate(profile.mouvement);

    // The opening sentence becomes the chapeau; the rest stays on the plate.
    var paras = portraitParas(profile.portrait || '');
    if (chapoEl && paras.length > 1) {
      chapoEl.innerHTML = colorizeMovements(pinyinHtml(paras.shift()));
      chapoEl.hidden = false;
    }
    portraitEl.innerHTML = paras
      .map(function (p) { return '<p>' + colorizeMovements(pinyinHtml(p)) + '</p>'; })
      .join('');

    var ENERGIE_LBL = {
      'Vide': t('energy_vide', 'À reconstituer'),
      'Plein': t('energy_plein', 'Débordante'),
      'Équilibré': t('energy_equilibre', 'Équilibrée')
    };

    // One value per row: an optional pastille or movement ink, then the word.
    function valueEl(text, cls, dotCls, note) {
      var el = document.createElement('span'), part;
      if (cls) el.className = cls;
      if (dotCls) {
        part = document.createElement('span');
        part.className = 'bq-profile__dot ' + dotCls;
        part.setAttribute('aria-hidden', 'true');
        el.appendChild(part);
      }
      el.appendChild(document.createTextNode(text));
      if (note) {
        part = document.createElement('span');
        part.className = 'bq-profile__val-note';
        part.textContent = ' ' + note;
        el.appendChild(part);
      }
      return el;
    }

    var rows = [];
    var mvtVals = [];
    if (profile.mouvement) {
      mvtVals.push(valueEl(mvtLabel(profile.mouvement), 'bq-profile__val--' + bq.slug(profile.mouvement)));
    }
    if (profile.mouvement_secondaire) {
      mvtVals.push(valueEl(
        mvtLabel(profile.mouvement_secondaire),
        'bq-profile__val--' + bq.slug(profile.mouvement_secondaire),
        '',
        t('support_suffix', '(appui)')
      ));
    }
    if (mvtVals.length) {
      rows.push({
        lbl: t(mvtVals.length > 1 ? 'row_movements' : 'row_movement', mvtVals.length > 1 ? 'Mouvements' : 'Mouvement'),
        vals: mvtVals
      });
    }
    if (profile.nature) {
      rows.push({
        lbl: t('row_nature', 'Nature'),
        vals: [valueEl(t('nat_' + profile.nature, profile.nature), '', 'bq-profile__dot--' + bq.slug(profile.nature))]
      });
    }
    if (Array.isArray(profile.saveurs) && profile.saveurs.length) {
      rows.push({
        lbl: t(profile.saveurs.length > 1 ? 'row_flavours' : 'row_flavour', profile.saveurs.length > 1 ? 'Saveurs' : 'Saveur'),
        vals: profile.saveurs.map(function (sv) { return valueEl(t('sav_' + sv, sv), ''); })
      });
    }
    if (profile.vide_plein) {
      rows.push({
        lbl: t('row_energy', 'Énergie'),
        vals: [valueEl(ENERGIE_LBL[profile.vide_plein] || profile.vide_plein, '')]
      });
    }

    rows.forEach(function (row) {
      var r = document.createElement('div');
      r.className = 'bq-profile__row';
      var dt = document.createElement('dt');
      dt.className = 'bq-profile__row-lbl';
      dt.textContent = row.lbl;
      r.appendChild(dt);
      var dd = document.createElement('dd');
      dd.className = 'bq-profile__row-val';
      row.vals.forEach(function (v, i) {
        if (i) {
          var sep = document.createElement('span');
          sep.className = 'bq-profile__val-sep';
          sep.setAttribute('aria-hidden', 'true');
          sep.textContent = '·';
          dd.appendChild(sep);
        }
        dd.appendChild(v);
      });
      r.appendChild(dd);
      readingsEl.appendChild(r);
    });

    if (profile.divergence_constitution_moment && profile.constitution && profile.constitution !== profile.mouvement) {
      var consCn = movementCn(profile.constitution, profile.constitution_chinoise);
      var d = t('divergence', 'Lecture nuancée : votre constitution de fond est {constitution} {cn}. Vous traversez en ce moment une saison {mouvement}.')
        .replace('{constitution}', profile.constitution)
        .replace('{cn}', consCn ? '(' + consCn + ')' : '')
        .replace('{mouvement}', profile.mouvement)
        .replace(/\s{2,}/g, ' ');
      divergenceEl.innerHTML = colorizeMovements(pinyinHtml(d));
      divergenceEl.hidden = false;
    }

    if (typeof profile.confiance === 'number') {
      if (profile.confiance < 0.6) {
        confianceEl.innerHTML = t('confidence_low', 'Lecture incertaine. Pour aller plus loin, l\'avis d\'un praticien certifié sera plus précis :') + ' <a href="' + bq.escapeHTML(FALLBACK_URL) + '" rel="noopener" target="_blank">christine-mtc.fr</a>.';
        confianceEl.classList.add('is-low');
        confianceEl.hidden = false;
      } else if (profile.confiance < 0.8) {
        confianceEl.textContent = t('confidence_mid', 'Cette lecture peut s\'affiner avec un praticien certifié.');
        confianceEl.hidden = false;
      }
    }

    loadProducts(profile.filtres);

    if (redoBtn) {
      redoBtn.addEventListener('click', function () {
        try {
          localStorage.removeItem('botaqi_profile');
          localStorage.removeItem('botaqi_profile_date');
          sessionStorage.removeItem('botaqi_orienteur_session');
        } catch (e) {}
        location.reload();
      });
    }

    // The movement's plate, cloned from the inert template the section ships;
    // the four others are never fetched.
    function mountPlate(mouvement) {
      var fig = document.getElementById('bq-profile-plate'),
        slot = document.getElementById('bq-profile-mount'),
        tpl = document.getElementById('bq-profile-plates'),
        key = ELEM_KEY[mouvement],
        src;
      if (!fig || !slot || !tpl || !tpl.content || !key) return;
      src = tpl.content.querySelector('[data-bq-mvt="' + key + '"] figure');
      if (!src) return;
      slot.appendChild(src.cloneNode(true));
      fig.hidden = false;
    }

    function buildFilterParams(filtres) {
      var p = new URLSearchParams();
      if (Array.isArray(filtres.movements)) {
        filtres.movements.forEach(function (m) { p.append('filter.p.m.tcm.movements', m); });
      }
      if (Array.isArray(filtres.thermal_nature)) {
        filtres.thermal_nature.forEach(function (n) { p.append('filter.p.m.tcm.thermal_nature', n); });
      }
      if (Array.isArray(filtres.flavors)) {
        filtres.flavors.forEach(function (f) { p.append('filter.p.m.tcm.flavors', f); });
      }
      if (Array.isArray(filtres.category)) {
        filtres.category.forEach(function (c) { p.append('filter.p.m.tcm.category', c); });
      }
      return p;
    }

    // Progressive filter relaxation: narrowest to broadest, to avoid zero results.
    async function loadProducts(f) {
      var has = function (x) { return Array.isArray(x) && x.length; };
      var levels = [];
      if (has(f.category)) {
        levels.push({ movements: f.movements, category: f.category, thermal_nature: f.thermal_nature, flavors: f.flavors });
        levels.push({ movements: f.movements, category: f.category, thermal_nature: f.thermal_nature });
        levels.push({ movements: f.movements, category: f.category });
      }
      levels.push({ movements: f.movements, thermal_nature: f.thermal_nature, flavors: f.flavors });
      levels.push({ movements: f.movements, thermal_nature: f.thermal_nature });
      levels.push({ movements: f.movements });

      var seenQs = {}, jobs = [];
      for (var i = 0; i < levels.length; i++) {
        var params = buildFilterParams(levels[i]);
        var qs = params.toString();
        if (!qs || seenQs[qs]) continue;
        seenQs[qs] = true;
        jobs.push({ level: levels[i], promise: fetchProducts(params) });
      }
      var results = await Promise.all(jobs.map(function (j) { return j.promise; }));

      var seen = {}, fine = [], broad = [];
      for (var r = 0; r < results.length; r++) {
        var isFine = has(jobs[r].level.category) || (!has(f.category) && r === 0);
        var items = results[r] || [];
        for (var j = 0; j < items.length; j++) {
          var k = productKey(items[j]);
          if (k && !seen[k]) {
            seen[k] = true;
            (isFine ? fine : broad).push(items[j]);
          }
        }
      }

      if (!fine.length && !broad.length) {
        productsEl.innerHTML = '<p class="bq-profile__none">' + t('no_products', 'Aucun produit ne correspond pour le moment : refaites une lecture, ou explorez la boutique depuis le menu.') + '</p>';
        return;
      }
      renderProducts(fine, broad);
    }

    function productKey(item) {
      var a = item.querySelector('a[href*="/products/"]');
      if (a) return (a.getAttribute('href') || '').split('?')[0];
      return (item.textContent || '').trim().slice(0, 60);
    }

    function gridItems(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return Array.from(doc.querySelectorAll('.product-grid__item'));
    }

    // A 200 is authoritative for this filter even with zero items, so the full page
    // is a fallback only when the section itself is unavailable.
    async function fetchProducts(params) {
      // Locale prefix: unprefixed, cards come back in the shop's primary
      // language on every other market.
      var url = bq.root(host) + 'collections/all?';
      var sectioned = new URLSearchParams(params);
      sectioned.set('section_id', 'bq-profile-results');
      try {
        var res = await fetch(url + sectioned.toString(), { headers: { 'accept': 'text/html' } });
        if (res.ok) return gridItems(await res.text());
      } catch (e) {}
      try {
        var full = await fetch(url + params.toString(), { headers: { 'accept': 'text/html' } });
        if (full.ok) return gridItems(await full.text());
      } catch (e) {}
      return [];
    }

    function renderProducts(fine, broad) {
      productsEl.innerHTML = '';
      var both = fine.length && broad.length;
      if (fine.length) {
        if (both) productsEl.appendChild(subTitle(t('best_match', 'Ce qui vous correspond le mieux')));
        renderGrid(fine);
      }
      if (broad.length) {
        if (both) productsEl.appendChild(subTitle(t('around_movement', 'Autour de votre Mouvement')));
        renderGrid(broad);
      }
    }

    function subTitle(txt) {
      var h = document.createElement('h3');
      h.className = 'bq-profile__subsection';
      h.textContent = txt;
      return h;
    }

    function renderGrid(items) {
      var ul = document.createElement('ul');
      ul.className = 'bq-profile__grid';
      productsEl.appendChild(ul);

      var BATCH = 8;
      var idx = 0;
      function appendBatch() {
        var end = Math.min(idx + BATCH, items.length);
        var base = idx;
        for (; idx < end; idx++) {
          var li = document.createElement('li');
          li.className = 'bq-profile__grid-item';
          li.style.setProperty('--i', idx - base);
          li.appendChild(items[idx].cloneNode(true));
          ul.appendChild(li);
        }
      }
      appendBatch();

      if (idx >= items.length) return;

      var sentinel = document.createElement('div');
      sentinel.className = 'bq-profile__sentinel';
      productsEl.appendChild(sentinel);

      if (!('IntersectionObserver' in window)) {
        while (idx < items.length) appendBatch();
        sentinel.remove();
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.unobserve(sentinel);
        appendBatch();
        if (idx >= items.length) { io.disconnect(); sentinel.remove(); return; }
        io.observe(sentinel);
      }, { rootMargin: '600px 0px' });
      io.observe(sentinel);
    }

    // Canonical pinyin per Movement: the model's own tones are sometimes malformed.
    function movementCn(mouvement, fallback) {
      var MAP = { 'Bois': '木 Mù', 'Feu': '火 Huǒ', 'Terre': '土 Tǔ', 'Métal': '金 Jīn', 'Eau': '水 Shuǐ' };
      return MAP[mouvement] || bq.fixPinyin(fallback || '');
    }

    function pinyinHtml(s) {
      return bq.wrapPinyin(bq.escapeHTML(bq.fixPinyin(s || '')));
    }

    // Operates on already-escaped HTML; .bq-pinyin is taken inside the bold.
    function colorizeMovements(html) {
      return String(html).replace(
        /(^|[^\w>])(Bois|Feu|Terre|Métal|Eau)\b(\s*<span class="bq-pinyin">[^<]*<\/span>)?/g,
        function (_, pre, m, annot) {
          return pre + '<strong class="bq-mvt bq-mvt--' + bq.slug(m) + '">' + m + (annot || '') + '</strong>';
        }
      );
    }

    // One paragraph per sentence.
    function portraitParas(text) {
      var parts = String(text || '').match(/[^.!?…]+[.!?…]+(?:\s*[»")\]]+)?/g);
      if (!parts || parts.length < 2) return [String(text || '')];
      return parts.map(function (p) { return p.trim(); }).filter(Boolean);
    }
  }

  document.querySelectorAll('.bq-profile').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.bq-profile').forEach(init);
  });
})();
